<template>
    <section class="content">
        <app-menu v-if="isLoggedIn"></app-menu>
        <div class="container-fluid">
            <div class="block-header">
                <button type="submit" class="btn general-button btn-success waves-effect pull-left" v-on:click.prevent="backrolelist">
                    Back
                </button>
            </div>
            <br>
            <div class="row clearfix" >
                <div class="col-lg-12 col-md-12 col-sm-12 col-xs-12">
                    <div class="alert alert-success hide" id="alertSuccess">
                        <button type="button" class="close" data-dismiss="alert" aria-label="Close"><span aria-hidden="true">&times;</span></button>
                        <strong>Permissions Added Successfully</strong>
                    </div>
                </div>
            </div>
            <div class="row clearfix">
                <div class="col-lg-12 col-md-12 col-sm-12 col-xs-12">
                    <div class="card form-header-task">
                        <div class="header">
                            <h2 id="permissionsHeader">
                                Create Permissions
                                <!--<small>Add Calls and Emails</small>-->
                            </h2>
                        </div>

                        <div class="body full-task-main">
                            <form id="Permissionsform">                                

                                <div class="body col-xs-12 col-sm-6">
                                    <label for="name">Permissions Name</label>
                                    <input type="text" id="name" name="name" class="form-control"
                                           placeholder="Enter Permissions Name" v-model="name" 
                                           v-validate="'required'">
                                    <!--v-validate="'required|max:190'">-->


                                    <span v-show="errors.has('name')" class="help is-danger" v-if="errors.has('name')"><font color="red">Permissions Name is Required</font></span>
                                </div>

                                <div class="row clearfix" >
                                    <div class="col-lg-12 col-md-12 col-sm-12 col-xs-12">
                                        <div class="alert alert-warning hide" id="alertError">
                                            <button type="button" class="close" data-dismiss="alert" aria-label="Close"><span aria-hidden="true">&times;</span></button>
                                            <strong id="errorMsg" class="error"></strong>
                                        </div>
                                    </div>
                                </div>

                                <div class="row clearfix"></div>
                                <div class="button-demo">
                                    <input id="addPermissionsBtn" type="submit" value="Save" class="btn general-button btn-success waves-effect pull-left" v-on:click.prevent="AddPermissions()">
                                    <input id="addAndContinuePermissionsBtn" type="submit" value="Save and Continue" class="btn general-button btn-success waves-effect pull-left" v-on:click.prevent="AddPermissions(flag='Save and Continue')">
                                    <input id="CancelPermissions" type="submit" value="Cancel" class="btn general-button btn-success waves-effect pull-left" v-on:click.prevent="backrolelist">
                                </div>
                                <div class="row clearfix"></div>
                            </form>
                        </div>
                    </div>
                </div>
            </div>
        </div>
    </section>
</template>

<script>
    import index from "../../router";
    import Vue from 'vue';
    // import {addTask, getCustomer, updateTask, list_taskUrl} from '../config'
    import FrontMenu from '@/components/partials/FrontMenu';
    import VeeValidate from 'vee-validate';
    Vue.use(VeeValidate);
    import EventBus from '../event-bus';
    import SessioMixin from '../../mixins/sessionmixin';
    // import moment from 'moment'

    Vue.component('app-menu', FrontMenu)
    var segments = '';
    export default {
        name: "RoleCreate",
        mixins: [SessioMixin],
        data() {
            return {
                isLoggedIn: false,
                created_by: '',
                updated_by: '',
                name: '',
            }
        },
        beforeMount: function () {
            var app = this;
            var check = window.localStorage.getItem('api_token');

            if (check != null) {
                this.isLoggedIn = true;
            }
        },
        mounted: function () {
            $(".removeActive").removeClass('active');
            $("#menupermission").addClass('active');
            if (localStorage.getItem("menu_small") == '1') {
                this.menuSmall();
            } else {
                this.menuBig();
            }
            //    setTimeout(function () {
            $('.datetimepicker').bootstrapMaterialDatePicker({
                // format: 'dddd DD MMMM YYYY - HH:mm',
                format: 'MM/DD/YYYY HH:mm:ss',
                clearButton: true,
                weekStart: 1
            });
            // },1000);
            var self = this;
            $(function () {
                $("#due_date").on('change', function () {
                    self.due_date = $("#due_date").val();
                })
            });

            var path = window.location.pathname;
            segments = path.split("/");
            var self = this;
            if (segments[3]) {
                self.showLoader();
                self.loadPermissions()
                $('#addAndContinuePermissionsBtn').hide();
                $("#addPermissionsBtn").val('Update');
                $("#permissionsHeader").text('Edit Permissions');
            }
            var userObj = localStorage.getItem('user_obj');
            if (userObj != null) {
                var userJson = JSON.parse(userObj);
                EventBus.$emit("logged-in", false, userJson["first_name"], userJson["last_name"], userJson["email"]);
            }
        },
        methods: {
            backrolelist() {
                var self = this;
                self.$router.push('/listpermissions');
            },
            AddPermissions(flag) {
                this.$validator.validate().then(result => {
                    if (result) {
                        var path = window.location.pathname;
                        var segments = path.split("/");
                        var self = this;
                        self.showLoader();
                        //console.log(segments[3]);
                        if (segments[3]) {
                            //console.log(segments[3]);
                            $("#addPermissionsBtn").val('Updating ...');
                            $("#addPermissionsBtn").prop('disabled', true);
                            // $("#addAndContinueCaseBtn").prop('disabled',true);
                            $("#CancelPermissions").prop('disabled', true);
                        } else {
                            if (flag == 'Save and Continue') {
                                $("#addAndContinuePermissionsBtn").val('Saving ...');
                                $("#addAndContinuePermissionsBtn").prop('disabled', true);
                                $("#addPermissionsBtn").prop('disabled', true);
                                $("#CancelPermissions").prop('disabled', true);
                            } else {
                                $("#addPermissionsBtn").val('Saving ...');
                                $("#addPermissionsBtn").prop('disabled', true);
                                $("#addAndContinuePermissionsBtn").prop('disabled', true);
                                $("#CancelPermissions").prop('disabled', true);
                            }
                        }

                        var fields = $('#Permissionsform').serializeArray();
                        // fields.push({name: 'priority', value: self.priority.value});
                        // fields.push({name: 'status', value: self.status.value});
                        // fields.push({name: 'customer_id', value: self.customer_id.value});
                        // fields.push({name: 'user_id', value: self.user_id.value});
                        this.$validator.validateAll();
                        this.$validator.errors.clear();

                        if (segments[3]) {
                            fields.push({name: 'id', value: segments[3]});
                        } else {
                            fields.push({name: 'id', value: 0});
                        }
                        $.ajax({
                            url: process.env.ROOT_API + "/permissions/create",
                            type: "POST",
                            data: fields,
                            headers: {
                                'Accept': 'application/json',
                                "Access-Control-Allow-Origin": '*',
                                "Authorization": "Bearer " + localStorage.getItem("api_token"),
                                'Access-Control-Allow-Headers': 'Origin, Content-Type, Authorization,X-Requested-With',
                                "Cache-Control": "no-cache"
                            },
                            dataType: 'json',
                            success: function (data) {
                                self.hideLoader();
                                if (segments[3]) {
                                    //console.log(segments[3]);
                                    $("#addPermissionsBtn").val('Update');
                                    $("#addPermissionsBtn").prop('disabled', false);
                                    $("#CancelPermissions").prop('disabled', false);

                                } else {
                                    if (flag == 'Save and Continue') {
                                        $("#addAndContinuePermissionsBtn").val('Save and Continue');
                                        $("#addAndContinuePermissionsBtn").prop('disabled', false);
                                        $("#addPermissionsBtn").prop('disabled', false);
                                        $("#CancelPermissions").prop('disabled', false);
                                    } else {
                                        $("#addPermissionsBtn").val('Save');
                                        $("#addPermissionsBtn").prop('disabled', false);
                                        $("#addAndContinuePermissionsBtn").prop('disabled', false);
                                        $("#CancelPermissions").prop('disabled', false);

                                    }
                                }
                                if (data.status == "success") {
                                    if (flag == 'Save and Continue') {
                                        $('html, body').animate({scrollTop: '0px'}, 500);
                                        $(".alert-success").toggleClass('show');
                                        self.name = '';
                                        setTimeout(function () {
                                            $('.alert-success').removeClass('show');
                                            $('.alert-success').addClass('hide');
                                        }, 5000);

                                    } else {
                                        self.$router.push('/listpermissions');
                                    }

                                } else {
                                    // $(".alert-warning").toggleClass('show');
                                    if (data.content.length > 0) {
                                        var err = "";
                                        for (var i = 0; i < data.content.length; i++) {
                                            err += data.content[i] + "<br>";
                                        }
                                        $("#errorMsg").html(err);
                                        $(".alert-warning").toggleClass('show');
                                        setTimeout(function () {
                                            $('.alert-warning').removeClass('show');
                                            $('.alert-warning').addClass('hide');
                                        }, 5000);
                                    }
                                }

                            },
                            error: function (jqXHR, exception) {
                                self.hideLoader();
                                if (segments[3]) {
                                    $("#addPermissionsBtn").val('Update');
                                    $("#addPermissionsBtn").prop('disabled', false);
                                    $("#CancelPermissions").prop('disabled', false);
                                    $("#errorMsg").html(jqXHR.responseJSON.message);
                                    $(".alert-warning").toggleClass('show');
                                    setTimeout(function () {
                                        $('.alert-warning').removeClass('show');
                                        $('.alert-warning').addClass('hide');
                                    }, 5000);
                                } else {

                                    if (flag == 'Save and Continue') {
                                        $("#addAndContinuePermissionsBtn").prop('disabled', false);
                                        $("#addAndContinuePermissionsBtn").val('Save and Continue');
                                        $("#addPermissionsBtn").prop('disabled', false);
                                        $("#CancelPermissions").prop('disabled', false);
                                        $("#errorMsg").html(jqXHR.responseJSON.message);
                                        $(".alert-warning").toggleClass('show');
                                        self.name = '';
                                        setTimeout(function () {
                                            $('.alert-warning').removeClass('show');
                                            $('.alert-warning').addClass('hide');
                                        }, 5000);

                                    } else {
                                        $("#addPermissionsBtn").val('Save');
                                        $("#addPermissionsBtn").prop('disabled', false);
                                        $("#addAndContinuePermissionsBtn").prop('disabled', true);
                                        $("#CancelPermissions").prop('disabled', false);
                                        $("#errorMsg").html(jqXHR.responseJSON.message);
                                        $(".alert-warning").toggleClass('show');
                                        setTimeout(function () {
                                            $('.alert-warning').removeClass('show');
                                            $('.alert-warning').addClass('hide');
                                        }, 5000);

                                    }

                                    if (jqXHR.status == 0) {
                                        self.errorMsg = "Remote server can not be reachable";
                                    } else {
                                        //redirect to login page if user not authenticated
                                        if (jqXHR.status == 401) {
                                            //clear previous data
                                            localStorage.removeItem('user_obj');
                                            localStorage.removeItem('api_token');
                                            //EventBus.$emit("logged-in", true, "", "");
                                            self.$router.push("/login");
                                        }

                                        $("#errorMsg").html(jqXHR.responseJSON.message);
                                        $(".alert-warning").toggleClass('show');
                                        setTimeout(function () {
                                            $('.alert-warning').removeClass('show');
                                            $('.alert-warning').addClass('hide');
                                        }, 5000);
                                    }
                                }
                            }
                        });
                    }
                });
            },

            loadPermissions() {

                var path = window.location.pathname;
                segments = path.split("/");
                //console.log(segments[3]);
                var self = this;
                $.ajax({
                    url: process.env.ROOT_API + "/permissions/" + segments[3],
                    type: "GET",
                    headers: {
                        'Accept': 'application/json',
                        "Access-Control-Allow-Origin": '*',
                        "Authorization": "Bearer " + localStorage.getItem("api_token"),
                        'Access-Control-Allow-Headers': 'Origin, Content-Type, Authorization,X-Requested-With',
                        "Cache-Control": "no-cache"
                    },
                    // dataType: 'json',
                    success: function (data) {
                        self.hideLoader();
                        self.name = data[0].name;
                    },
                    error: function (jqXHR, exception) {
                        self.hideLoader();
                        if (jqXHR.status == 0) {
                            self.error = "Remote server can not be reachable";
                        } else {
                            //redirect to login page if user not authenticated
                            if (jqXHR.status == 401) {
                                //clear previous data
                                localStorage.removeItem('user_obj');
                                localStorage.removeItem('api_token');
                                //EventBus.$emit("logged-in", true, "", "");
                                self.$router.push("/login");
                            }
                            self.error = jqXHR.responseJSON.message;
                        }
                    }
                })
            },
            menuSmall: function () {
                $('.opensidebar').show();
                $('.closesidebar').hide();
                $('.menu').addClass('menusmall');
                $('.sidemenu li a span,.legal').addClass('displaynone');
                $('.sidemenu li a i').addClass('displayicons');
                $('.sidebar').css({width: "70px"});
                $('.content').css({marginLeft: "70px"});
                $("html, body").animate({scrollTop: 0}, 10);
            },
            menuBig: function () {
                $('.opensidebar').hide();
                $('.closesidebar').show();
                $('.menu').removeClass('menusmall');
                $('.sidemenu li a span,.legal').removeClass('displaynone');
                $('.sidemenu li a i').removeClass('displayicons');
                $('.sidebar').css({width: "260px"});
                $('.content').css({marginLeft: "260px"});
                $("html, body").animate({scrollTop: 0}, 10);
            }
        }
    }
</script>

<style scoped>

</style>



// WEBPACK FOOTER //
// src/components/rolePermission/PermissionsCreate.vue